import { render, staticRenderFns } from "./MeterReadingLoginForm.vue?vue&type=template&id=5125b7cf&"
import script from "./MeterReadingLoginForm.vue?vue&type=script&lang=ts&"
export * from "./MeterReadingLoginForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports